<div class=" p-0 bggradientBG w-100 h-100 d-flex flex-column justify-content-xl-between justify-content-xxl-between" [ngClass]="{'vh-100 overflow-y-scroll':!navbarlg}">
    <div class="w-100 m-0 p-0 bg-transparent p-xl-0 p-xxl-0  py-2 py-xl-0 py-xxl-0 order-xl-1 order-2 order-xxl-1 order-lg-2 order-md-2 order-sm-2 ">
      <nav class="navbar navbar-expand-xl w-100 p-0  bg-transparent gap-1">
        <div class="container-fluid bg-transparent p-0  w-100 d-flex flex-xxl-column flex-xl-column">
          <div class="py-lg-3 px-lg-4 bg-transparent col-xxl-12 col-xl-12 d-flex justify-content-start">
              
            <a class="" 
                (click)="routeTo('')"
                [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' ">
                <img
                class=""
                width="140"
                src="/documents/assets/images/icons/mobi developer white.svg"
                alt="mobi"
              />
          </a> 
        </div>
          <button class="navbar-toggler mx-3 border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTopic" aria-controls="navbarTopic" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class=" w-100 collapse navbar-collapse bg-transparent mt-0 " id="navbarTopic">
            <ul class="navbar-nav w-100 border-top bg-transparent ">
              <li class="nav nav-pills w-100 bg-transparent ">
                <div class="nav-pills d-flex flex-column w-100 bg-transparent ">
                    <div class="container-fluid p-0 w-100 bg-transparent ">
                      <ul class="nav flex-column">
                        <li class="nav nav-pills">
                          <button class="nav-link ps-3 ps-2 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                          [ngClass]="activeTopic===''? 'active':''"
                          (click)="routeTo('')"
                          [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                          [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                          ><span class="ps-2 text-white">Getting Started</span></button>
                        </li>
                        </ul>
                    </div>
                    <div class="bg-transparent ">
                      <caption class="fs10 ms-2 py-1 fw-semibold">
                        <span class="ps-3 color51cb49 text-nowrap ">PAYMENT METHODS</span>
                      </caption>
                      <div class="m-0 p-0  " [ngSwitch]="region">
                        <div class="m-0 p-0 vstack gap-0  " *ngSwitchCase="'Malaysia'">
                          <div class="accordion rounded-0 border-0 accordion-flush " id="accordionMA">
                            <!-- IB -->
                            <div class="accordion-item m-0 rounded-0 border-0 ">
                              <div class="accordion-header p-0 m-0 rounded-0 border-0">
                                <button class="accordion-button m-0 text-white fs14 collapsed border-0 rounded-0 p-3 py-2" type="button" data-bs-toggle="collapse" data-bs-target="#Malaysia_IB" aria-expanded="false" aria-controls="Malaysia_payment">
                                 <span class="ms-2 text-white fw-normal">Internet Banking</span>
                                </button>
                              </div>
                              <div id="Malaysia_IB" class="accordion-collapse  rounded-0 border-0 m-0 collapse" data-bs-parent="#accordionMA">
                                <div class="accordion-body  m-0 p-0 rounded-0 border-0">
                                  
                                  <ul class=" px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="fpx" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                      [ngClass]="{'active' : activeTopic==='fpx'}"
                                      (click)="routeTo('Malaysia/internet-banking/fpx')"
                                      [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                      [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                      ><span class="ms-3 text-white fw-normal">FPX Banking</span></button>
                                    </li>
                                    </ul>                                                                   
                                </div>
                              </div>
                            </div>
                            <!-- ewallets -->
                            <div class="accordion-item rounded-0 border-0 bg-transparent ">
                              <div class="accordion-header rounded-0 bg-transparent ">
                                <button class="accordion-button text-white fs14 collapsed rounded-0 p-3 py-2" type="button" data-bs-toggle="collapse" data-bs-target="#Malaysia_ewallet" aria-expanded="false" aria-controls="Malaysia_payments">
                                  <span class="ms-2 text-white fw-normal">eWallets</span>
                                </button>
                              </div>
                              <div id="Malaysia_ewallet" class="accordion-collapse collapse bg-transparent " data-bs-parent="#accordionMA">
                                <div class="accordion-body p-0 bg-transparent ">
                                  
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="boost" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                      [ngClass]="{'active':activeTopic==='boost'}"
                                      (click)="routeTo('Malaysia/ewallets/boost')"
                                      [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                      [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                      ><span class="ms-3 text-white fw-normal">Boost</span></button>
                                    </li>
                                  </ul>
                                  
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="grabpay" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                      [ngClass]="{'active':activeTopic==='grabpay'}"
                                      (click)="routeTo('Malaysia/ewallets/grabpay')"
                                      [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                      [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                      ><span class="ms-3 text-white fw-normal">GrabPay</span></button>
                                    </li>
                                  </ul>
                                  
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="touchngo" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                      [ngClass]="{'active':activeTopic==='touchngo'}"
                                      (click)="routeTo('Malaysia/ewallets/touchngo')"
                                      [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                      [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                      ><span class="ms-3 text-white fw-normal">Touch 'n Go</span> </button>
                                    </li>
                                  </ul>
                                  
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="shopeepay" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                      [ngClass]="{'active':activeTopic==='shopeepay'}"
                                      (click)="routeTo('Malaysia/ewallets/shopeepay')"
                                      [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                      [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                      ><span class="ms-3 text-white fw-normal">Shopee Pay</span> </button>
                                    </li>
                                  </ul>

                                  <ul class="px-0 flex-column">
                                    <li class="px-0 nav-pills">
                                      <button id="duitnowqr" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                      [ngClass]="activeTopic==='duitnowqr'? 'active':''"
                                      (click)="routeTo('Malaysia/ewallets/duitnowqr')"
                                      [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                      [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                      ><span class="ms-3 text-white fw-normal">DuitNow QR</span></button>
                                    </li>
                                    </ul>

                                </div>
                              </div>
                            </div>                     
                          </div>
                          <!-- 7 Eleven -->
                          <ul class="px-0 flex-column">
                            <li class="nav nav-pills">
                              <button id="ezycash" class="nav-link ps-3 ps-3 py-2 fs14 border-0 rounded-0 text-start text-black text-decoration-none payment_method_list w-100 m-0" 
                               type="button" data-bs-toggle="collapse" data-bs-target="#Malaysia_IB"
                              [ngClass]="{'active':activeTopic==='ezycash'}"
                              (click)="routeTo('Malaysia/ezycash')"
                              [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                              [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                              ><span class="ms-2 text-white fw-normal ">EZYCASH </span></button>
                            </li>
                          </ul>
                          <!-- payout MA -->
                          <ul class="px-0 flex-column">
                            <li class="nav nav-pills">
                              <button id="ma-payout" class="nav-link ps-3 ps-3 py-2 fs14 border-0 rounded-0 text-start text-black text-decoration-none payment_method_list w-100 m-0" 
                               type="button" data-bs-toggle="collapse" data-bs-target="#Malaysia_IB"
                              [ngClass]="{'active':activeTopic==='ma-payout'}"
                              (click)="routeTo('Malaysia/payout/ma-payout')"
                              [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                              [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                              ><span class="ms-2 text-white fw-normal ">Payout </span></button>
                            </li>
                          </ul>
                        </div>

                        <!-- indo -->
                        <div class="m-0 p-0 vstack gap-0" *ngSwitchCase="'Indonesia'">                                  
                            <ul class="px-0 flex-column">
                              <li class="nav nav-pills">
                                <button id="virtual-account" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                [ngClass]="{'active':activeTopic==='virtual-account'}"
                                (click)="routeTo('Indonesia/virtual-account')"
                                [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                ><span class="ms-3 text-white fw-normal">Virtual Account </span></button>
                              </li>
                            </ul>
                            <ul class="px-0 flex-column">
                              <li class="nav nav-pills">
                                <button id="qris" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                [ngClass]="{'active':activeTopic==='qris'}"
                                (click)="routeTo('Indonesia/qris')"
                                [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                ><span class="ms-3 text-white fw-normal">QRIS</span> </button>
                              </li>
                            </ul>
                            <ul class="px-0 flex-column">
                              <li class="nav nav-pills">
                                <button id="ewallets" class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0" 
                                [ngClass]="{'active':activeTopic==='ewallets'}"
                                (click)="routeTo('Indonesia/ewallets')"
                                [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                ><span class="ms-3 text-white fw-normal">eWallets</span> </button>
                              </li>
                            </ul>
                            <ul class="px-0 flex-column">
                              <li class="nav nav-pills">
                                <button id="indo-payout" class="nav-link ps-3 ps-3 py-2 fs14 border-0 rounded-0 text-start text-black text-decoration-none payment_method_list w-100 m-0" 
                                [ngClass]="{'active':activeTopic==='indo-payout'}"
                                (click)="routeTo('Indonesia/indo-payout')"
                                [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' "
                                ><span class="ms-3 text-white fw-normal">Payout</span> </button>
                              </li>
                            </ul>
                        </div>
                        <!-- caption for second set of contents (Plugins) -->
                        <caption class="fs10 ms-2 py-1 fw-semibold" *ngSwitchCase="'Malaysia'">
                          <span class="ps-3 color51cb49 text-nowrap ">PLUGINS</span>
                        </caption>
                        <!-- Malaysia plugins ecommerce -->
                        <div class="m-0 p-0 vstack gap-0" *ngSwitchCase="'Malaysia'">
                          <!-- ecommerce -->
                          <div class="accordion rounded-0 border-0 accordion-flush bg-transparent" id="accordionMAPlugin">                       
                            <div class="accordion-item m-0 rounded-0 border-0 bg-transparent ">
                              <div class="accordion-header p-0 m-0 rounded-0 bg-transparent border-0">
                                <button class="accordion-button m-0 text-white fs14 collapsed border-0 rounded-0 p-3 py-2" type="button"
                                  data-bs-toggle="collapse" data-bs-target="#Malaysia_Ecomm" aria-expanded="false"
                                  aria-controls="Malaysia_payment">
                                  <span class="ms-2 text-white fw-normal">Ecommerce</span>
                                </button>
                              </div>
                              <div id="Malaysia_Ecomm" class="accordion-collapse bg-transparent rounded-0 border-0 m-0 collapse"
                                data-bs-parent="#accordionMAPlugin">
                                <div class="accordion-body bg-transparent m-0 p-0 rounded-0 border-0">
                      
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="php"
                                        class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0"
                                        [ngClass]="{'active':activeTopic==='php'}" 
                                        (click)="routeTo('Malaysia/ecommerce/php')"
                                        [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                        [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' ">
                                        <span class="ms-3 text-white fw-normal">Php</span>
                                        </button>
                                    </li>
                                  </ul>
                      
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="woo-commerce"
                                        class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0"
                                        [ngClass]="{'active':activeTopic==='woo-commerce'}"
                                        (click)="routeTo('Malaysia/ecommerce/woo-commerce')"
                                        [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                        [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' ">
                                        <span class="ms-3 text-white fw-normal">WooCommerce</span> </button>
                                    </li>
                                  </ul>
                      
                                  <!-- <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button
                                        class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0"
                                        [ngClass]="{'active':activeTopic==='shopify'}" 
                                        (click)="routeTo('Malaysia/ecommerce/shopify')"
                                        [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                        [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' ">
                                        <span class="ms-3 text-white fw-normal">Shopify</span> </button>
                                    </li>
                                  </ul> -->
                      
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="opencart"
                                        class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0"
                                        [ngClass]="{'active':activeTopic==='opencart'}" 
                                        (click)="routeTo('Malaysia/ecommerce/opencart')"
                                        [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                        [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' ">
                                        <span class="ms-3 text-white fw-normal">Opencart</span> </button>
                                    </li>
                                  </ul>
                      
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="prestashop"
                                        class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0"
                                        [ngClass]="{'active':activeTopic==='prestashop'}" 
                                        (click)="routeTo('Malaysia/ecommerce/prestashop')"
                                        [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                        [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' ">
                                        <span class="ms-3 text-white fw-normal">Prestashop</span> </button>
                                    </li>
                                  </ul>
                      
                                  <ul class="px-0 flex-column">
                                    <li class="nav nav-pills">
                                      <button id="magento"
                                        class="nav-link ps-3 ps-3 py-2 border-0 rounded-0 text-start text-white text-decoration-none fw-medium fs14 w-100 m-0"
                                        [ngClass]="{'active':activeTopic==='magento'}" 
                                        (click)="routeTo('Malaysia/ecommerce/magento')"
                                        [attr.data-bs-toggle]="navbarlg ? 'collapse' : '' "
                                        [attr.data-bs-target]="navbarlg ? '#navbarTopic' : '' ">
                                        <span class="ms-3 text-white fw-normal">Magento</span> </button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>  
                        </div>
                      </div>  
                      <hr>                    
                    </div>
                  </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>